<script setup lang="ts">

import { usePresentation } from '@presentation/Types';
import IntroductionPageOptions from '@presentation/Components/IntroductionPageOptions.vue';

const presentation = usePresentation();

</script>

<template>

    <div class="flex flex-col min-h-full grow items-center justify-center gap-8">
        
        <Image src="/connected-vehicles-logo-icon.png" class="h-24 2xl:h-32" />
        <Image src="/connected-vehicles-text-dark-mode.png" class="!h-14 2xl:!h-16" />

        <h1 class="text-2xl md:text-3xl lg:text-4xl font-semibold uppercase opacity-30 text-center">
            Retention, Rewards &amp; Revenue
        </h1>

        <IntroductionPageOptions />

        <button 
            @click.stop="() => presentation.goto( presentation.sections[ 1 ].name )"
            class="bg-white/20 hover:bg-white/30 rounded-md p-4 shadow tracking-wider font-semibold uppercase mt-4 transition duration-100">
            Start Presentation
        </button>


        <a href="https://connectedvehicles.com.au" class="absolute bottom-4 opacity-50">www.connectedvehicles.com.au</a>

    </div>

</template>